import * as React from 'react'
import { AdminMainConnected } from './AdminMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const AdminMainExamples = () => {
  return (
    <div className="AdminMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <AdminMainConnected />
      </Provider>
    </div>
  )
}
